import React from "react";

const DigitalMenu = () => {
  return (
    <div className="__sweven_products-dm">
      <div className="__sweven_products-dm--image">
        <img src="./images/dm-big.png" alt="DM DEMO" />
      </div>
      <div className="__sweven_products-dm--description">
        <div className="__sweven_products-dm--description__title">
          Digital Menu
        </div>
        <div className="__sweven_products-dm--description__description">
          Digital Menu is the first Project of Sweven Incorporate Private
          Limited. It is the converted digitalized menu from traditional paper
          menu for Restaurant, Bar, Lounge and Lodges. Smoother, easier and
          user-friendly product is specialized and full of creativeness for
          customer satisfactory.
        </div>
        <div className="__sweven_products-dm--flow">
          <img src="./images/dm-flow.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default DigitalMenu;
